import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedCategory: null,
    selectedService: null,
    cartItems: [],
    slotData: null,
    bookedData: null,
    currentFlow: null, // 'cleaning', 'electrician', 'plumber'
};

const homeServicesSlice = createSlice({
    name: 'homeServices',
    initialState,
    reducers: {
        setHomeServiceFlow: (state, action) => {
            state.currentFlow = action.payload;
        },
        setSelectedCategory: (state, action) => {
            state.selectedCategory = action.payload;
        },
        setSelectedService: (state, action) => {
            state.selectedService = action.payload;
        },
        addToCart: (state, action) => {
            const existingItem = state.cartItems.find(item => item.id === action.payload.id);
            if (existingItem) {
                existingItem.quantity += 1;
            } else {
                state.cartItems.push({ ...action.payload, quantity: 1 });
            }
        },
        removeFromCart: (state, action) => {
            const existingItem = state.cartItems.find(item => item.id === action.payload.id);
            if (existingItem) {
                if (existingItem.quantity > 1) {
                    existingItem.quantity -= 1;
                } else {
                    state.cartItems = state.cartItems.filter(item => item.id !== action.payload.id);
                }
            }
        },
        clearCart: (state) => {
            state.cartItems = [];
        },
        setSlotData: (state, action) => {
            state.slotData = action.payload;
        },
        setBookedData: (state, action) => {
            state.bookedData = action.payload;
        },
        resetHomeServicesState: (state) => {
            return initialState;
        }
    },
});

export const {
    setHomeServiceFlow,
    setSelectedCategory,
    setSelectedService,
    addToCart,
    removeFromCart,
    clearCart,
    setSlotData,
    setBookedData,
    resetHomeServicesState
} = homeServicesSlice.actions;

export default homeServicesSlice.reducer;
